import HttpService from './HttpService';


export const companiesList = (signal, page, items, applicationTypeKey, searchKey, searchedVal) => {
    const http = new HttpService();
    if (searchedVal.trim().length != 0) {
        var url = "users/companies-list/0?page=" + page + '&items=' + items + '&searchKey=' + searchKey + '&searchKeyValue=' + searchedVal + '&applicationTypeKey=' + applicationTypeKey;
    } else {
        var url = "users/companies-list/0?page=" + page + '&items=' + items + '&applicationTypeKey=' + applicationTypeKey;
    }
    const tokenId = "user-token";
    return http.getDataBySignal(url, tokenId, signal).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}

export const updateCompanyService = (credentials) => {
    const http = new HttpService();
    let loginUrl = "users/update-company";
    const tokenId = "user-token";
    return http.postData(credentials, loginUrl, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}
